import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import ContactHero from './ContactHero';
import ContactMain from './ContactMain';

const BsidesContact = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <ContactHero />
            <ContactMain />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default BsidesContact;
